/** Mirrors FRIEND_TOPIC_KEY in backend/src/topics.ts. */
export const FRIEND_TOPIC_KEY = "friends";

export const TOPICS: { key: string; i18nKey: string }[] = [
  { key: "self_reflection", i18nKey: "topic_self_identity" },
  { key: "values_identity", i18nKey: "topic_values_meaning" },
  { key: "life_stories", i18nKey: "topic_life_stories" },
  { key: "hypotheticals", i18nKey: "topic_hypotheticals" },
  { key: "relationships", i18nKey: "topic_love_relationships" },
  { key: "sex_intimacy", i18nKey: "topic_sex_intimacy" },
  { key: "social_dynamics", i18nKey: "topic_social_friends" },
  { key: "social_cringe", i18nKey: "topic_awkward_cringe" },
  { key: "food_drink", i18nKey: "topic_food_drink" },
  { key: "sports", i18nKey: "topic_sports_fitness" },
  { key: "music", i18nKey: "topic_music" },
  { key: "pop_culture", i18nKey: "topic_movies_tv_culture" },
  { key: "lifestyle", i18nKey: "topic_lifestyle_style" },
  { key: "philosophy", i18nKey: "topic_philosophy_ethics" },
  { key: "fears_dark", i18nKey: "topic_dark_uncomfortable" },
  { key: "politics", i18nKey: "topic_politics_society" },
  { key: "career", i18nKey: "topic_career_ambition" },
  { key: "gaming", i18nKey: "topic_games_gaming" },
  { key: "humor", i18nKey: "topic_humor_absurd" },
  { key: "travel", i18nKey: "topic_travel_places" },
  // Derived, not tagged: the backend resolves this one from the answer pool ({{friend}} cards),
  // so it needs the lobby's friend pool filled to have any content. See topics.ts on the backend.
  { key: FRIEND_TOPIC_KEY, i18nKey: "topic_rank_friends" },
];

export const TOPIC_KEYS = TOPICS.map((t) => t.key);
